import {styled} from '@linaria/react';
import {Badge} from './GenericBadges';
import {badgeColors} from './badgeColors';

export const CampaignSaleBadge = styled(Badge)`
  color: ${badgeColors.colors.sale};
`;
